
<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content>

    <div [innerHTML] ="message"></div>

</mat-dialog-content>


<div mat-dialog-actions>

    <div class="w-full">
        <mce-save-cancel [config]="saveCancelConfig()"
                         (action)="onSaveCancelAction($event)">
        </mce-save-cancel>

    </div>

</div>
